import styled from 'styled-components'
export const StyledTabs = styled.div`

  .ant-tabs-nav .ant-tabs-nav-wrap {
    border-bottom: 1px solid #E0E0E0;
  }
  
  .ant-tabs-tab.ant-tabs-tab-active {
    border-bottom: 6px solid #F99B00 !important;
  }

  .ant-tabs-card {
    .ant-tabs-tab {
      background: #FAFAFA !important;
      color: #121212 !important;
      .ant-tabs-tab-btn {
        font-size: 14px;
      }
      &.ant-tabs-tab-active {
        background: #C21110 !important;
        .ant-tabs-tab-btn {
          color: #FFF !important;
        }
      }
      &.ant-tabs-tab-disabled {
        .ant-tabs-tab-btn {
          opacity: 0.5;
        }
      }
    }
  }
  .ant-tabs-tab {
    padding-left: 20px !important;
    padding-right: 20px !important;
    margin: unset;
    .ant-tabs-tab-btn {
      font-size: 20px;
      font-weight: normal;
    }
  }

  @media only screen and (max-width: 768px) {
    .ant-tabs-tab {
      padding-left: 20px !important;
      padding-right: 20px !important;
      .ant-tabs-tab-btn {
        font-size: 16px !important;
      }
    }
    .img-absolute {
      display: none !important;
    }
  }

  @media only screen and (max-width: 540px) {
    .ant-tabs-tab {
      padding-left: 10px !important;
      padding-right: 10px !important;
      .ant-tabs-tab-btn {
        font-size: 14px !important;
      }
    }
    .img-absolute {
      display: none !important;
    }
  }

  @media only screen and (max-width: 414px) {
    /* For mobile phones: */
    .ant-tabs-tab {
      padding-left: 15px !important;
      padding-right: 15px !important;
      .ant-tabs-tab-btn {
        font-size: 14px !important;
      }
    }
    .img-absolute {
      display: none !important;
    }
  }

  @media only screen and (max-width: 375px) {
    /* For mobile phones: */
    .ant-tabs-tab {
      padding-left: 11px !important;
      padding-right: 11px !important;
      .ant-tabs-tab-btn {
        font-size: 13px !important;
      }
    }
    .img-absolute {
      display: none !important;
    }
  }

  @media only screen and (max-width: 320px) {
    /* For mobile phones: */
    .ant-tabs-tab {
      padding-left: 7px !important;
      padding-right: 7px !important;
      .ant-tabs-tab-btn {
        font-size: 12px !important;
      }
    }
    .img-absolute {
      display: none !important;
    }
  }
`
